import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useToast } from '../../contexts/ToastContext';
import { Modal, ModalFooter } from '../ui/modal';

function DeleteTaskModal({ show, handleClose, task, onTaskDeleted }) {
  const [isLoading, setIsLoading] = useState(false);
  const addToast = useToast();

  const handleDelete = async () => {
    if (!task) return;

    setIsLoading(true);
    
    try {
      const { error } = await supabase
        .from('tasks')
        .delete()
        .eq('id', task.id);

      if (error) {
        console.error('Error deleting task:', error);
        addToast('Error deleting task: ' + error.message, 'error');
      } else {
        addToast('Task deleted successfully', 'success');
        onTaskDeleted(task.id);
        handleClose();
      }
    } catch (error) {
      console.error('Error deleting task:', error);
      addToast('Error deleting task: ' + error.message, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={show} onClose={handleClose} title="Delete Task">
      <div className="space-y-3">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to delete the task "{task?.name}"?
        </p>
        <p className="text-sm text-red-600 dark:text-red-400">
          This action cannot be undone.
        </p>
      </div>
      
      <ModalFooter>
        <button
          type="button"
          onClick={handleClose}
          disabled={isLoading}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDelete}
          disabled={isLoading}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteTaskModal;
